import { HYDRATE } from 'next-redux-wrapper';
import { initialState } from './state';
import {
  SET_USER,
  SET_LOADING_ITEM,
  REMOVE_LOADING_ITEM,
  SET_ERROR_ITEM,
  REMOVE_ERROR_ITEM,
  SET_COMMON_DATA,
  SET_SHOW_BANNERS,
  SET_SETTINGS,
  CLEAR_ERROR_ITEM,
} from '@constants';

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
      };
    case SET_SETTINGS:
      return {
        ...state,
        settings: action.payload,
      };
    case SET_COMMON_DATA:
      return {
        ...state,
        common: action.payload,
      };
    case SET_LOADING_ITEM: {
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload]: true,
        },
      };
    }
    case REMOVE_LOADING_ITEM: {
      const loading = state.loading;
      delete loading[action.payload];

      return {
        ...state,
        loading,
      };
    }
    case SET_ERROR_ITEM: {
      const error = action.payload.error;

      const errObject = {
        code: typeof error === 'object' ? error?.response?.status : '',
        message: typeof error === 'object' ? error?.message || error?.name : error,
      };

      return {
        ...state,
        errors: {
          ...state.errors,
          [action.payload.type]: errObject,
        },
      };
    }
    case REMOVE_ERROR_ITEM: {
      const { [action.payload]: _removed, ...newErrors } = state.errors;
      return {
        ...state,
        errors: newErrors,
      };
    }
    case SET_SHOW_BANNERS: {
      return {
        ...state,
        showBanners: { ...state.showBanners, ...action.payload },
      };
    }
    default:
      return state;
  }
};
